const IGI_LAB_SHAPE_DATA = [
    {
        "LAB_SHAPE": "ANTIQUE CUSHION CUT"
    },
    {
        "LAB_SHAPE": "BAGUETTE"
    },
    {
        "LAB_SHAPE": "BAGUETTE CUT"
    },
    {
        "LAB_SHAPE": "BAGUETTE STEP CUT"
    },
    {
        "LAB_SHAPE": "BUTTERFLY CUT"
    },
    {
        "LAB_SHAPE": "BUTTERFLY MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUSHION ANTIQUE BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUSHION BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUSHION MIXED CUT"
    },
    {
        "LAB_SHAPE": "CUSHION MIXED CUT 100 FACETS"
    },
    {
        "LAB_SHAPE": "CUSHION MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUSHION MODIFIED BRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "CUSHION ROSE CUT"
    },
    {
        "LAB_SHAPE": "CUSHION STEP CUT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED MIXED CUT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED RECTANGULAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED RECTANGULAR MIXED CUT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED RECTANGULAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED RECTANGULAR ROSE CUT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED RECTANGULAR STEP CUT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED RECTANGULAR TABLET"
    },
    {
        "LAB_SHAPE": "CUT CORNERED SQUARE BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED SQUARE MIXED CUT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED SQUARE MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED SQUARE STEP CUT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED SQUARE TABLET"
    },
    {
        "LAB_SHAPE": "CUT CORNERED TRIANGULAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUT CORNERED TRIANGULAR STEP CUT"
    },
    {
        "LAB_SHAPE": "DECAGON MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "DECAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "DODECAGON MIXED CUT"
    },
    {
        "LAB_SHAPE": "DODECAHEDRAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "DODECAHEDRAL STEP CUT"
    },
    {
        "LAB_SHAPE": "EMERALD"
    },
    {
        "LAB_SHAPE": "EMERALD CUT"
    },
    {
        "LAB_SHAPE": "EMERALD MIXED CUT"
    },
    {
        "LAB_SHAPE": "EMERALD ROSE CUT"
    },
    {
        "LAB_SHAPE": "FACETED LONG TEARDROP"
    },
    {
        "LAB_SHAPE": "FLOWER CUT"
    },
    {
        "LAB_SHAPE": "FLOWER MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "FREEFORM"
    },
    {
        "LAB_SHAPE": "FREEFORM BRILLIANT"
    },
    {
        "LAB_SHAPE": "FREEFORM MIXED CUT"
    },
    {
        "LAB_SHAPE": "FREEFORM MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "HALF MOON BRILLIANT"
    },
    {
        "LAB_SHAPE": "HALF MOON MIXED CUT"
    },
    {
        "LAB_SHAPE": "HALF MOON MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "HALF MOON STEP CUT"
    },
    {
        "LAB_SHAPE": "HEART BRILLIANT"
    },
    {
        "LAB_SHAPE": "HEART FACETED"
    },
    {
        "LAB_SHAPE": "HEART MIXED CUT"
    },
    {
        "LAB_SHAPE": "HEART MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "HEART ROSE CUT"
    },
    {
        "LAB_SHAPE": "HEPTAGONAL MODIFIED STEP CUT"
    },
    {
        "LAB_SHAPE": "HEPTAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "HEXADECAGONAL MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "HEXAGONAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "HEXAGONAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "HEXAGONAL MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "HEXAGONAL MODIFIED STEP CUT"
    },
    {
        "LAB_SHAPE": "HEXAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "HORSE HEAD"
    },
    {
        "LAB_SHAPE": "KITE BRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "KITE MIXED CUT"
    },
    {
        "LAB_SHAPE": "KITE MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "KITE STEP CUT"
    },
    {
        "LAB_SHAPE": "LOZENGE BRILLIANT"
    },
    {
        "LAB_SHAPE": "LOZENGE MIXED CUT"
    },
    {
        "LAB_SHAPE": "LOZENGE ROSE CUT"
    },
    {
        "LAB_SHAPE": "LOZENGE STEP CUT"
    },
    {
        "LAB_SHAPE": "MARQUISE BRILLIANT"
    },
    {
        "LAB_SHAPE": "MARQUISE MIXED CUT"
    },
    {
        "LAB_SHAPE": "MARQUISE MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "MARQUISE STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED CUSHION MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED DECAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED EMERALD CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED HEART MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED HEART STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED HEPTAGONAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED HEXAGONAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED HEXAGONAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED KITE STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED LEAF BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED LEAF MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED LEAF STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED LOZENGE MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED LOZENGE STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED MARQUISE STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED NONAGON STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED OCTAGON STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED OCTAGONAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED OCTAGONAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED OCTAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED OVAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED OVAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED OVAL STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PEAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED PEAR MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PEAR STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PENTAGON MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PENTAGON STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PENTAGONAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PENTAGONAL ROSE CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PENTAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PIE MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PRINCESS CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED PRINCESS MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED RECTANGULAR CUSHION MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED RECTANGULAR CUSHION STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED SHIELD BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED SHIELD MIXED CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED SHIELD STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED SQUARE EMERALD CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED TRIANGULAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED TRIANGULAR STEP CUT"
    },
    {
        "LAB_SHAPE": "MOON MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "MOVAL BRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "NONAGON STEP CUT"
    },
    {
        "LAB_SHAPE": "OCTAGONAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "OCTAGONAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "OCTAGONAL MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "OCTAGONAL ROSE CUT"
    },
    {
        "LAB_SHAPE": "OCTAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "OLD EUROPEAN CUT"
    },
    {
        "LAB_SHAPE": "OLD MINE BRILLIANT"
    },
    {
        "LAB_SHAPE": "OLD MINE CUT"
    },
    {
        "LAB_SHAPE": "OVAL"
    },
    {
        "LAB_SHAPE": "OVAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "OVAL FACETED"
    },
    {
        "LAB_SHAPE": "OVAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "OVAL MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "OVAL MODIFIED BRILLIANT 100 FACETS"
    },
    {
        "LAB_SHAPE": "OVAL POLYGON MIXED CUT"
    },
    {
        "LAB_SHAPE": "OVAL POLYGON STEP CUT"
    },
    {
        "LAB_SHAPE": "OVAL ROSE CUT"
    },
    {
        "LAB_SHAPE": "OVAL STEP CUT"
    },
    {
        "LAB_SHAPE": "OVATE BRILLIANT"
    },
    {
        "LAB_SHAPE": "PARALLELOGRAM BRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "PEAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "PEAR MIXED CUT"
    },
    {
        "LAB_SHAPE": "PEAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "PEAR ROSE CUT"
    },
    {
        "LAB_SHAPE": "PEAR STEP CUT"
    },
    {
        "LAB_SHAPE": "PENTAGON BRILLIANT"
    },
    {
        "LAB_SHAPE": "PENTAGON MIXED CUT"
    },
    {
        "LAB_SHAPE": "PENTAGON MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "PENTAGON ROSE CUT"
    },
    {
        "LAB_SHAPE": "PENTAGON STEP CUT"
    },
    {
        "LAB_SHAPE": "PENTAGONAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "PENTAGONAL MIXED CUT"
    },
    {
        "LAB_SHAPE": "PENTAGONAL MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "PENTAGONAL ROSE CUT"
    },
    {
        "LAB_SHAPE": "PENTAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "PIE MIXED CUT"
    },
    {
        "LAB_SHAPE": "PRINCESS"
    },
    {
        "LAB_SHAPE": "PRINCESS CUT"
    },
    {
        "LAB_SHAPE": "PRINCESS MIXED CUT"
    },
    {
        "LAB_SHAPE": "RABBIT BRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "RADIANT CUT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR CUSHION BRILLIANT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR CUSHION MIXED CUT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR CUSHION MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR CUSHION STEP CUT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR MIXED CUT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR MODIFIED PRINCESS"
    },
    {
        "LAB_SHAPE": "RECTANGULAR PRINCESS"
    },
    {
        "LAB_SHAPE": "RECTANGULAR PRINCESS CUT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR PRINCESS MIXED CUT"
    },
    {
        "LAB_SHAPE": "RHOMBOID LEAF MIXED CUT"
    },
    {
        "LAB_SHAPE": "ROSE CUT"
    },
    {
        "LAB_SHAPE": "ROUND"
    },
    {
        "LAB_SHAPE": "ROUND BRILLIANT"
    },
    {
        "LAB_SHAPE": "ROUND CORNERED RECTANGULAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "ROUND CORNERED RECTANGULAR MIXED CUT"
    },
    {
        "LAB_SHAPE": "ROUND CORNERED RECTANGULAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "ROUND MIXED CUT"
    },
    {
        "LAB_SHAPE": "ROUND MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "ROUND MODIFIED BRILLIANT 100 FACETS"
    },
    {
        "LAB_SHAPE": "ROUND POLYGON MIXED CUT"
    },
    {
        "LAB_SHAPE": "ROUND POLYGON MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "ROUND ROSE CUT"
    },
    {
        "LAB_SHAPE": "SHIED MIXED CUT"
    },
    {
        "LAB_SHAPE": "SHIELD MIXED CUT"
    },
    {
        "LAB_SHAPE": "SHIELD STEP CUT"
    },
    {
        "LAB_SHAPE": "SQUARE CUSHION BRILLIANT"
    },
    {
        "LAB_SHAPE": "SQUARE CUSHION CUT"
    },
    {
        "LAB_SHAPE": "SQUARE CUSHION MIXED CUT"
    },
    {
        "LAB_SHAPE": "SQUARE CUSHION MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "SQUARE CUSHION ROSE CUT"
    },
    {
        "LAB_SHAPE": "SQUARE CUT CORNERED MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "SQUARE EMERALD"
    },
    {
        "LAB_SHAPE": "SQUARE EMERALD CUT"
    },
    {
        "LAB_SHAPE": "SQUARE EMERALD MIXED CUT"
    },
    {
        "LAB_SHAPE": "SQUARE MIXED CUT"
    },
    {
        "LAB_SHAPE": "SQUARE STEP CUT"
    },
    {
        "LAB_SHAPE": "STAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "TAPERED BAGUETTE"
    },
    {
        "LAB_SHAPE": "TAPERED EMERALD CUT"
    },
    {
        "LAB_SHAPE": "TAPERED MODIFIED BAGUETTE"
    },
    {
        "LAB_SHAPE": "THREE LEAF CLOVER MIXED CUT"
    },
    {
        "LAB_SHAPE": "TRAPEZE BRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "TRAPEZE MIXED CUT"
    },
    {
        "LAB_SHAPE": "TRAPEZE MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "TRAPEZE ROSE CUT"
    },
    {
        "LAB_SHAPE": "TRAPEZE STEP CUT"
    },
    {
        "LAB_SHAPE": "TRAPEZIUM MODIFIED BRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "TRAPEZOID BRILLIANT"
    },
    {
        "LAB_SHAPE": "TRAPEZOID STEP CUT"
    },
    {
        "LAB_SHAPE": "TRIANGULAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "TRIANGULAR MIXED CUT"
    },
    {
        "LAB_SHAPE": "TRIANGULAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "TRIANGULAR STEP CUT"
    },
    {
        "LAB_SHAPE": "TRILLIANT CUT"
    },
    {
        "LAB_SHAPE": "TRILLIANT MIXED CUT"
    },
    {
        "LAB_SHAPE": "TWELVE SIDED MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "TWELVE SIDED STEP CUT"
    }
]

export default IGI_LAB_SHAPE_DATA;